import React from 'react'
import styles from './styles.module.css'
import { cx } from '@emotion/css'

export function AssetBreadCrumb({ breadcrumbs }) {
  const totalItemsLength = breadcrumbs.length
  return (
    <div className={styles['breadcrumb']} data-testid="asset-breadcrumb">
      <div className={styles['breadcrumb-wrapper']}>
        {breadcrumbs.map((item, idx) => {
          let isCurrentPage = idx === totalItemsLength - 1
          if (isCurrentPage) {
            return (
              <span className={cx(styles['breadcrumb__link--text'], styles['breadcrumb__current--page'])}>{item.name}</span>
            )
          }
          return (
            <>
              <span onClick={() => item.action(idx)} className={styles['breadcrumb__link--text']}>{item.name}</span>
              <span className={styles['breadcrumb__link--slash']}>/</span>
            </>
          )
        })}
      </div>
    </div >
  )
}
